import { isLocal } from '@lcsc-ui/utils/baseUrl';
import { doGet, doPost } from '@lcsc-ui/utils/request';

let APIHost = '/lcsc-order';
if (isLocal) {
  APIHost = 'https://devorder.szlcsc.com';
}

// node请求接口
export default {
  selectWarehouse: `${APIHost}/select/customer/master/warehouse`,
};

let domain = 'lcscOrderApiUrl';
if (isLocal) {
  domain = 'https://devorder-api.szlcsc.com';
}

// 星级询价
export function asyncBeforeEnquiryAdd(query) {
  return doGet(domain, `/async/before/enquiry/add/v2?way=1`, query);
}

// 校验无价格先行询价
export function asyncCheckNoPriceEnquiry(body) {
  return doPost(domain, `/async/check/noprice/enquiry`, body, {
    noErrorModal: true,
  });
}

// 保存无价格先行询价
export function asyncNoPriceEnquirySave(body) {
  return doPost(domain, `/async/noprice/enquiry/save`, body, {
    noErrorModal: true,
  });
}
